export const enum TaskName {
  CONTENT_FILE = "n",
  CONTENT_PAGED = "p",
  TASK_MERGE = "M",
  TASK_PLOT = "P",
  TASK_RASTERIZE = "R",
  TASK_SPLIT = "S",
  TASK_ZIP = "Z",
  TRACKING = "t",
}
